import { fetch } from '../fetch';
import { setLanguage } from '../language/actions';

export enum AuthenticationType {
    authenticationChecking = 'AUTHENTICATION_CHECKING',
    authenticationCheckingFailed = 'AUTHENTICATION_CHECKING_FAILED',
    authenticationLoggedIn = 'AUTHENTICATION_LOGGED_IN',
    authenticationLogout = 'AUTHENTICATION_LOGOUT',
    authenticationUpdateAreEmploymentTaxesDetailsRequired = 'AUTHENTICATION_UPDATE_ARE_EMPLOYMENT_TAXES_DETAILS_REQUIRED',
    authenticationUpdateProfilePicture = 'AUTHENTICATION_UPDATE_PROFILE_PICTURE',
}

export function logout(redirectUrl = '/home') {
    return async (_dispatch: any) => {
        return fetch('/api/session', 'DELETE').then(() => {
            window.location.href = redirectUrl;
        });
    };
}

function checkingFailed() {
    return { type: AuthenticationType.authenticationCheckingFailed };
}

function checking() {
    return { type: AuthenticationType.authenticationChecking };
}

export function receiveLogin(json: any) {
    return (dispatch: any) => {
        dispatch({
            type: AuthenticationType.authenticationLoggedIn,
            user: json,
        });

        if (json.language) {
            dispatch(setLanguage(json.language, true));
        }
    };
}

export function updatePractitionerProfilePicture(profilePictureUrl: string) {
    return (dispatch: any) => {
        dispatch({
            type: AuthenticationType.authenticationUpdateProfilePicture,
            profilePictureUrl: profilePictureUrl,
        });
    };
}

export function fetchAuthenticationAction() {
    return async (dispatch: any) => {
        dispatch(checking());

        return fetch('/api/session', 'GET').then((response: any) => {
            if (response.status === 403) {
                dispatch(checkingFailed());
            } else if (response.status >= 400) {
                console.log(response);
            } else {
                return response.json().then((json: any) => dispatch(receiveLogin(json)));
            }
        });
    };
}

export function updateAreEmploymentTaxesDetailsRequired(areEmploymentTaxesDetailsRequired: boolean) {
    return (dispatch: (action: { areEmploymentTaxesDetailsRequired: boolean; type: string }) => void) => {
        dispatch({
            areEmploymentTaxesDetailsRequired: areEmploymentTaxesDetailsRequired,
            type: AuthenticationType.authenticationUpdateAreEmploymentTaxesDetailsRequired,
        });
    };
}
